"use strict";

var _react = _interopRequireWildcard(require("react"));
var _addons = require("@storybook/addons");
var _theming = require("@storybook/theming");
var _api = require("@storybook/api");
var _components = require("@storybook/components");
var _getCookie = _interopRequireDefault(require("./getCookie"));
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const IconButtonWithLabel = (0, _theming.styled)(_components.IconButton)(() => ({
  display: 'inline-flex',
  alignItems: 'center'
}));
const ActiveViewportLabel = _theming.styled.div(({
  theme
}) => ({
  display: 'inline-block',
  textDecoration: 'none',
  padding: 10,
  fontWeight: theme.typography.weight.bold,
  fontSize: theme.typography.size.s2 - 1,
  lineHeight: '1',
  height: 40,
  border: 'none',
  borderTop: '3px solid transparent',
  borderBottom: '3px solid transparent',
  background: 'transparent'
}));
const Dropdown = () => {
  const cookieTheme = (0, _getCookie.default)('cssVariables');
  const addonParams = (0, _api.useParameter)(_constants.ADDON_PARAM_KEY, {});
  const {
    theme,
    defaultTheme,
    files
  } = addonParams;
  const id = files && Object.hasOwnProperty.call(files, cookieTheme) && cookieTheme;
  const [selected, setSelected] = (0, _react.useState)(theme || id);
  const emit = (0, _api.useChannel)({});
  (0, _react.useEffect)(() => {
    if (!selected) {
      setSelected(theme || id || defaultTheme);
    }
  }, [selected, theme, defaultTheme, id]);
  function handleChange(onHide, value) {
    const newValue = value.indexOf(_constants.CLEAR_LABEL) > -1 ? _constants.CLEAR_LABEL : value;
    setSelected(newValue);
    emit('cssVariablesChange', {
      id: newValue
    });
    onHide();
  }
  function toLink(value, active, onHide) {
    return {
      id: value,
      title: !value ? _constants.CLEAR_LABEL : value,
      onClick: () => handleChange(onHide, value),
      active
    };
  }
  function generateLinks(items, onHide) {
    // eslint-disable-next-line max-len
    const result = Object.keys(items).map(value => toLink(value, value === selected, onHide));
    if (selected !== _constants.CLEAR_LABEL && !defaultTheme) {
      result.unshift(toLink(_constants.CLEAR_LABEL, false, onHide));
    }
    return result;
  }
  if (files) {
    return /*#__PURE__*/_react.default.createElement(_components.WithTooltip, {
      placement: "top",
      trigger: "click",
      tooltip: ({
        onHide
      }) => /*#__PURE__*/_react.default.createElement(_components.TooltipLinkList, {
        links: generateLinks(files, onHide)
      }),
      closeOnClick: true
    }, /*#__PURE__*/_react.default.createElement(IconButtonWithLabel, {
      key: "css themes",
      title: "CSS custom properties themes",
      active: Object.hasOwnProperty.call(files, selected)
    }, /*#__PURE__*/_react.default.createElement(_components.Icons, {
      icon: "paintbrush"
    }), /*#__PURE__*/_react.default.createElement(ActiveViewportLabel, {
      title: "Theme"
    }, selected || 'No theme')));
  }
  return null;
};
_addons.addons.register(_constants.ADDON_ID, () => {
  _addons.addons.add(_constants.ADDON_ID, {
    title: 'CSS Variables Theme',
    type: _addons.types.TOOL,
    match: ({
      viewMode
    }) => viewMode === 'story' || viewMode === 'docs',
    render: () => /*#__PURE__*/_react.default.createElement(Dropdown, null)
  });
});